module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("PART 1")]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_vm._v("The Problem of Technology")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_05_Part1"
    }
  }, [_vm._v("Part 1")]), _vm._v(" of this study is introductory. The main topics are presented in "), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_13_Part2"
    }
  }, [_vm._v("Part 2")]), _vm._v(" and in "), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_26_Part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3")]), _vm._v(". The first of these major topics is the character of contemporary life. The modern world and contemporary life particularly, so I will argue, have been shaped by technology, which has stamped them with a peculiar pattern and so given them their character. But although our world bears the imprint of technology, the pattern of technology is neither obvious nor exclusively dominant. It competes with and threatens to obliterate certain focal things and practices that center and order our lives in a profoundly different way. These focal concerns represent the other major theme of this inquiry. "), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_13_Part2"
    }
  }, [_vm._v("Part 2")]), _vm._v(", then, is intended to clarify and explicate the pattern of technology and the prevailing character of our time. Given a clear and intelligent view of technology, "), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_26_Part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3")]), _vm._v(" is to show how in the midst of technology we can become more conscious and confident of our focal concerns and how, against the background of technology, we can give them a central and consequential place in our lives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These remarks must appear dubious and perhaps cryptic. They are so in part because they are brief, but partly also because they summarize views at variance with the common understanding of technology. A careful introduction is thus needed to connect the major concerns of this book with current thought on technology and to clear the ground for another way of approaching the problem of technology. This is the task of "), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_05_Part1"
    }
  }, [_vm._v("Part 1")]), _vm._v(". It begins in "), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_06_Chapter1"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" with a more detailed sketch of the contrast between the established views of technology and the position developed in this book. In particular, it provides introductory illustrations of what is meant by the pattern of technology, the pivot of "), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_13_Part2"
    }
  }, [_vm._v("Part 2")]), _vm._v(", and by a matter of profound concern, the focus of "), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_26_Part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3")]), _vm._v(". It presents brief surveys of those two parts and, at the same time, clarifies the significance of scholarship and method for the task before us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In "), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_07_Chapter2"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(", the concept of technology that will guide this essay is tentatively sketched against the background of the presently dominant views of technology. The perspective on theories of technology is further elaborated in "), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_08_Chapter3"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" through a comparison of the present classification with one "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("developed by Carl Mitcham. This discussion points up more clearly and urgently the need for a fundamental and fruitful notion of technology; and it also suggests that the clarification of science and its connection with technology is the first task if that need is to be met. Accordingly, "), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_09_Chapter4"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" considers what status science as a mode of viewing and explaining the world has in the technological society. This leads, in "), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_10_Chapter5"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(", to an examination of the structure of scientific explanation. "), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_11_Chapter6"
    }
  }, [_vm._v("Chapter 6")]), _vm._v(", finally, develops and extends the understanding of science to include the problem of technology. It concludes that modern science is a necessary condition of modern technology and so is an understanding of one for the appreciation of the other; but science and technology are not the same thing nor essentially continuous with one another. Hence the character of technology requires an investigation and a method in its own right.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The chapters of "), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_05_Part1"
    }
  }, [_vm._v("Part 1")]), _vm._v(" are brief, and some readers may find them a needless obstacle. That would be a misunderstanding. Strong and unusual claims of the sort that can be found on occasion in "), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_13_Part2"
    }
  }, [_vm._v("Part 2")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226066295_26_Part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3")]), _vm._v(" are easily made by themselves. Even if one finds them immediately persuasive, or perhaps precisely when one does, one remains accountable to the established views, and one has an obligation to standards of thoroughness and circumspection in giving an account of one’s views. "), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_05_Part1"
    }
  }, [_vm._v("Part 1")]), _vm._v(", though not "), _c('a', {
    attrs: {
      "href": "#/xhtml/9780226066295_05_Part1"
    }
  }, [_vm._v("Part 1")]), _vm._v(" alone, is intended to meet those requirements.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19a59928","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780226066295_05_Part1.vue
// module id = 69
// module chunks = 0